import React, { useEffect, useState} from "react";
import { connect } from "react-redux";
import FormItem from "components/fields/FormItem";
import { DatePicker, Form, Input } from "antd";
import SelectOption from "components/select/SelectOption";
import { requiredField } from "utils/crudSagaHelper";
import {
    Sparkles,
    UserPlus,
    Briefcase,
    Building2,
    Award,
    FileText,
    Clock,
    Calendar,
    Send,
    ArrowRight,
    Users,
    User,
} from "lucide-react";
import Card from "components/card";
import TextArea from "antd/es/input/TextArea";
import { 
    getJobRoleRequestDetails, 
    doJobRoleRequestCreate, 
    getJobRoleBudget,
    getJobRoleDescription,
    getJobRoleSkills,
} from "../../../../redux/jobrolerequest/jobRoleRequestState";
import { MODULE_JOBROLE_REQS, DATE_FORMAT } from "variables/constants";
import dayjs from "dayjs";
import Button from "components/button";
import DynamicList from "components/fields/DynamicList";
import AIButton from "components/ai/aibutton";
import { InputNumber } from 'antd';
import AskEliButton from "components/button/AskEliButton";

const RequestForm = ({
	recordData,
	getDetails,
	doCreate, 
	onCancel,
	submitLabel,
	getRecord,
    user,
    jobRoleBudgetState,
    jobRoleBudget,
    jobRoleDescriptionState,
    jobRoleDescription,
    jobRoleSkillsState,
    jobRoleSkills,
    askAIJobRoleBudget,
    askAIJobRoleDescription,
    askAIJobRoleSkills,
	...props
}) => {

    const [form] = Form.useForm();
    const { recordId } = props;
    const [startDate, setStartDate] = useState(null);

    useEffect(() => {
        if(!recordId){
            getRecord(recordId);
        }
    }, [recordId, getRecord]);

    useEffect(() => {
        if (!jobRoleBudget?.message) return;
        const currentValue = form.getFieldValue('jrr_budget_range');
        if (currentValue !== jobRoleBudget.message){
            form.setFields([
                {
                    name: 'jrr_budget_range',
                    value: jobRoleBudget.message,
                    touched: true,
                },
            ]);
        }
    }, [jobRoleBudget, form]);

    useEffect(() => {
        if (!jobRoleDescription?.message) return;
        const currentValue = form.getFieldValue('jrr_job_requirements');
        if (currentValue !== jobRoleDescription.message){
            form.setFields([
                {
                    name: 'jrr_job_requirements',
                    value: jobRoleDescription.message,
                    touched: true,
                },
            ]);
        }
    }, [jobRoleDescription, form]);

    useEffect(() => {
        if (!jobRoleSkills?.message) return;
        const currentValue = form.getFieldValue('jro_preferred_qualifications');
        if (currentValue !== jobRoleSkills.message){
            form.setFields([
                {
                    name: 'jro_preferred_qualifications',
                    value: jobRoleSkills.message,
                    touched: true,
                },
            ]);
        }
    }, [jobRoleSkills, form]);

    useEffect(() => {
        resetForm();
    }, [recordData, form]);

    const handleAskAI = async (field) => {
        try {
            
            await form.validateFields([
                'jro_job_title',
                'jrr_department_id',
                'jrr_target_date',
            ]);

            const formData = form.getFieldsValue(true);
            const department = recordData?.departmentList?.find(
                (dept) => dept.value === formData.jrr_department_id
            );
            const priority = recordData?.priorityList?.find(
                (priority) => priority.value === formData.jrr_priority_id
            );
            const countryData = recordData?.countryList?.find(
                (country) => country.value === formData.jrr_country_id
            );

            const payload =  {
                field, 
                formData : {
                companyName: undefined,
                    positionTitle: formData.jro_job_title,
                    department: department?.label,
                    location: countryData.label,
                    urgencyLevel: priority?.label,
                    startDate: formData.jrr_target_date ? formData.jrr_target_date.toISOString() : undefined,
                    budget: formData.jrr_budget_range,
                    description: formData.jrr_job_requirements,
                    skills: undefined, //skills.filter((s) => s.trim() !== ""),
                }
            };

            if (field === "budget") {
                askAIJobRoleBudget(payload);
            }else if (field === "description") {
                askAIJobRoleDescription(payload);
            }else if (field === "skills") {
                askAIJobRoleSkills(payload);
            }

        } catch (error) {
            console.log('Validation failed:', error.errorFields);
        }
    };

    const onSubmit = (formData) => {
        try {
            console.log(formData);
            formData.jrr_target_date = formData.jrr_target_date?.format(DATE_FORMAT);
            formData.jro_job_description = formData.jrr_job_requirements;
            doCreate(formData);
    
        } catch (error) {
            console.error("Save failed:", error);
        }
    };

    const resetForm = () => {
        if(recordData){
            form.resetFields();
            const { job_role:jobRole, jrr_job_role_id, ...rest } = recordData;

            const initialValues = {
                ...rest,
                ...jobRole,
                jrr_id: recordData?.jrr_id ?? "",
                jrr_target_date: recordData?.jrr_target_date ? dayjs(recordData.jrr_target_date) : null,
                jro_job_title: jobRole?.jro_job_title ?? "",
                jro_key_responsibilities: Array.isArray(jobRole?.jro_key_responsibilities)
                    ? recordData.job_role.jro_key_responsibilities
                    : recordData.job_role.jro_key_responsibilities
                    ? JSON.parse(recordData.job_role.jro_key_responsibilities)
                    : [""],
                jro_preferred_qualifications: Array.isArray(jobRole?.jro_preferred_qualifications)
                    ? recordData.job_role.jro_preferred_qualifications
                    : recordData.job_role.jro_preferred_qualifications
                    ? JSON.parse(recordData.job_role.jro_preferred_qualifications)
                    : [""],
            };	
            form.setFieldsValue(initialValues);
        }
    };

    return (
        <Card className="rounded-2xl shadow-lg border-2 border-stale-200 max-w-[56rem] mx-auto overflow-hidden">
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 border-b rounded-t-2xl p-6 dark:from-purple-900 dark:to-white/10">
                <div className="flex items-center gap-4">
                    <div className="flex items-center justify-center rounded-xl bg-gradient-to-br from-purple-500 to-pink-500 backdrop-blur-xl shadow-md p-3 flex-shrink-0">
                        <UserPlus className="w-6 h-6 text-white" />
                    </div>
                    <div>
                        <h4 className="text-[18px] font-semibold text-slate-900 dark:text-slate-50">Request New Team Member</h4>
                        <p className="text-[14px] text-slate-700 dark:text-slate-200">
                            Submit a hiring request and we'll find the perfect candidate for your team
                        </p>
                    </div>
                </div>
            </div>

            <Form 
                form={form}
                layout="vertical" 
                onFinish={onSubmit} 
            >
                <FormItem
                    name="jrr_id"
                    hidden
                >
                    <Input type="hidden"/>
                </FormItem>

                <FormItem
                    name="jrr_status_id"
                    hidden
                >
                    <Input type="hidden"/>
                </FormItem>

                <FormItem
                    name="jrr_department_id"
                    hidden
                >
                    <Input type="hidden"/>
                </FormItem>
                
                <div className="pb-6 p-8 space-y-6">
                    { user?.user_role_ids.includes(3) && 
                        <FormItem
                            label="Client *"
                            name="jrr_client_id"
                            icon={User}
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select Client"
                                className="input-field"
                                options={recordData?.clientList}
                                size="large"
                                showSearch={true}
                            />
                        </FormItem>
                    }
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <FormItem
                            label="Position Title"
                            name="jro_job_title"
                            icon={Briefcase}
                            rules={[requiredField()]}
                        >
                            <Input
                                id="jro_job_title"
                                className="input-field"
                                placeholder="e.g., Senior Software Engineer" />
                        </FormItem>
                        <FormItem
                            label="Preferred Start Date *"
                            name="jrr_target_date"
                            icon={Calendar}
                            rules={[requiredField()]}
                            >
                                <DatePicker
                                    variant="borderless"
                                    className="input-field w-full bg-gray-50 rounded-lg flex items-center px-2"
                                    showSearch
                                    size="large"
                                />
                        </FormItem>
                        {/* <FormItem
                            label="Department *"
                            name="jrr_department_id"
                            icon={Building2}
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select Department"
                                className="input-field"
                                options={recordData?.departmentList}
                                size="large"
                            />
                        </FormItem> */}
                        
                        <FormItem
                            label="Urgency Level"
                            name="jrr_priority_id"
                            icon={Clock}
                        >
                            <SelectOption
                                placeholder="All Stages"
                                className="input-field"
                                options={recordData?.priorityList}
                                size="large"
                            />
                        </FormItem>
                        
                        <FormItem
                            label="Country"
                            name="jrr_country_id"
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select Country"
                                className="input-field"
                                options={recordData?.countryList}
                                size="large"
                            />
                        </FormItem>
                        <div className="flex w-full gap-2 items-center">
                            <FormItem
                                label="Budget Range"
                                name="jrr_budget_range"
                                icon={Award}
                                rules={[requiredField()]}
                                extra="w-full"
                                labelExtra={<AIButton state={jobRoleBudgetState} calllHandler={() => handleAskAI('budget')}/>}
                            >
                                <Input
                                    id="jrr_budget_range"
                                    placeholder="e.g., $80,000 - $120,000 AUD"
                                    className="input-field"
                                    suffix="/Staff"
                                />
                            </FormItem>
                        </div>
                        <FormItem
                            label="Headcount"
                            name="jrr_count"
                            icon={Users}
                            rules={[requiredField()]}
                            extra="mt-3"
                        >
                            <InputNumber id="jrr_count" 
                                size="large" 
                                min={1} 
                                max={1000}
                                defaultValue={1} 
                                className="input-field w-[100px] mt-3"
                            />
                        </FormItem>
                        <div className="md:col-span-2">
                            <FormItem
                                label="Role Requirements & Responsibilities"
                                name="jrr_job_requirements"
                                icon={FileText}
                                rules={[requiredField()]}
                                labelExtra={<AIButton state={jobRoleDescriptionState} calllHandler={() => handleAskAI('description')}/>}
                            >
                                <TextArea
                                    className="input-field"
                                    placeholder="Describe the key requirements, responsibilities, and qualifications for this role..." 
                                    rows={5}
                                />
                            </FormItem>
                            <p className="text-gray-500 text-[12px] sm:text-[13px]">
                                Include must-have experience level, and any specific qualifications 
                            </p>
                        </div>
                        <div className="md:col-span-2">
                            <DynamicList 
                                name="jro_preferred_qualifications"
                                label="Preferred Skills"
                                placeholder="Enter skills"
                                addButtonClass="text-gray-700 border border-dashed border-gray-700 dark:text-white dark:border-gray-100"
                                mode="edit"
                                icon={FileText}
                                recordData={recordData?.job_role?.jro_preferred_qualifications}
                                labelExtra={<AIButton state={jobRoleSkillsState} calllHandler={() => handleAskAI('skills')}/>}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 w-full">
                        <div className="p-4 rounded-xl bg-gradient-to-br from-purple-50 to-pink-50 border border-purple-200 dark:from-purple-900 dark:to-pink-900/10">
                            <div className="flex items-start gap-3">
                                <Sparkles className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5 dark:text-purple-400"/>
                                <div className="text-[13px]">
                                    <h4 className="font-semibold text-purple-900 dark:text-purple-100">What happens next?</h4>
                                    <p className=" text-purple-800 leading-relaxed dark:text-purple-200">
                                        Our recruitment team will review your request within 24 hours and will contact you for calibration.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <Button type="reset"
                            className="gap-2 border-2 border-gray-300 rounded-xl px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                            onClick={resetForm}>
                            <span className="dark:text-white">Clear Form</span>
                        </Button>

                        <Button type="submit"
                            className="flex-1 flex items-center justify-center gap-2 rounded-xl px-3 h-12 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white text-sm font-medium shadow-lg hover:shadow-xl transition-all dark:from-purple-800 dark:to-pink-800">
                            <Send className="w-4 h-4 mr-2"/>
                            <span>Submit Hiring Request</span>
                            <ArrowRight className="w-4 h-4 ml-2" />
                        </Button>
                    </div>
                </div>
            </Form>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    recordData: state.jobRoleRequest.jobRoleRequestDetails?.data,
    user: state.auth.user,
    jobRoleBudgetState: state.jobRoleRequest.aiJobRoleBudget,
    jobRoleBudget: state.jobRoleRequest.aiJobRoleBudget.data,
    jobRoleDescriptionState: state.jobRoleRequest.aiJobRoleDescription,
    jobRoleDescription: state.jobRoleRequest.aiJobRoleDescription.data,
    jobRoleSkillsState: state.jobRoleRequest.aiJobRoleSkills,
    jobRoleSkills: state.jobRoleRequest.aiJobRoleSkills.data,
});

const mapDispatchToProps = (dispatch) => ({
    getRecord: (id) => dispatch(getJobRoleRequestDetails(id)),
    doCreate: (data) => dispatch(doJobRoleRequestCreate(data)),

    askAIJobRoleBudget: (data) => dispatch(getJobRoleBudget(data)),
    askAIJobRoleDescription: (data) => dispatch(getJobRoleDescription(data)),
    askAIJobRoleSkills: (data) => dispatch(getJobRoleSkills(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestForm);
